import React, { useEffect, useState } from 'react';
import { useTeamDashboard } from '../TeamDashboardContext';
import './settings.css';

const NOTIF_TOGGLES = [
  { title: 'Budget alerts', sub: 'Alert below 20% remaining', defaultOn: true },
  { title: 'Work log notifications', sub: 'Notify on every work log', defaultOn: false },
  { title: 'Quality alerts', sub: 'Alert on critical bug submissions', defaultOn: true },
  { title: 'Email notifications', sub: 'Send alerts to owner email', defaultOn: true },
];

export default function SettingsPage() {
  const { showToast, theme, toggleTheme } = useTeamDashboard();
  const [mounted, setMounted] = useState(false);
  const [workspaceName, setWorkspaceName] = useState('Scrudix Dev Team');
  const [defaultRate, setDefaultRate] = useState('500');
  const [warningThreshold, setWarningThreshold] = useState('20');
  const [autoLock, setAutoLock] = useState(true);
  const [displayName, setDisplayName] = useState('Arjun Kumar');
  const [email, setEmail] = useState('arjun@scrudix.com');
  const [notifToggles, setNotifToggles] = useState(NOTIF_TOGGLES.map(t => t.defaultOn));

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 30);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="td-settings" data-theme={theme}>
      <div className="ptitle">Settings</div>
      <div className="psub">Workspace configuration</div>

      <div className="g2">
        {/* Left column */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div className={`card fu${mounted ? ' in' : ''}`}>
            <div className="ch"><span className="ct">Workspace</span></div>
            <div style={{ padding: 16 }}>
              <div className="fgroup">
                <label className="label">Workspace name</label>
                <input className="inp" value={workspaceName} onChange={e => setWorkspaceName(e.target.value)} />
              </div>
              <div className="fgroup">
                <label className="label">Default hourly rate (₹/hr)</label>
                <input className="inp" type="number" value={defaultRate} onChange={e => setDefaultRate(e.target.value)} />
              </div>
              <button className="btn-p" onClick={() => showToast('Saved', 'Workspace settings updated', 'success')}>Save changes</button>
            </div>
          </div>

          <div className={`card fu${mounted ? ' in' : ''}`} style={{ transitionDelay: '.05s' }}>
            <div className="ch"><span className="ct">Notifications</span></div>
            <div style={{ padding: '12px 16px' }}>
              {NOTIF_TOGGLES.map((tog, i) => (
                <div key={i} className="tog-row">
                  <div>
                    <div className="tog-title">{tog.title}</div>
                    <div className="tog-sub">{tog.sub}</div>
                  </div>
                  <div className={`tog${notifToggles[i] ? ' on' : ''}`} onClick={() => setNotifToggles(prev => prev.map((s, j) => j === i ? !s : s))} />
                </div>
              ))}
            </div>
          </div>

          <div className={`dzone fu${mounted ? ' in' : ''}`} style={{ transitionDelay: '.1s' }}>
            <div className="dzone-title">Danger zone</div>
            <div className="dzone-sub">These actions are permanent and cannot be undone.</div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <button className="btn-d" onClick={() => showToast('Confirm', 'This will reset all budget data', 'info')}>Reset budget</button>
              <button className="btn-d" onClick={() => showToast('Confirm', 'Contact support to delete workspace', 'info')}>Delete workspace</button>
            </div>
          </div>
        </div>

        {/* Right column */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div className={`card fu${mounted ? ' in' : ''}`} style={{ transitionDelay: '.06s' }}>
            <div className="ch"><span className="ct">Budget settings</span></div>
            <div style={{ padding: 16 }}>
              <div className="fgroup">
                <label className="label">Warning threshold (%)</label>
                <input className="inp" type="number" value={warningThreshold} onChange={e => setWarningThreshold(e.target.value)} />
              </div>
              <div className="fgroup">
                <label className="label">Auto-lock at ₹0</label>
                <div style={{ marginTop: 6, display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div className={`tog${autoLock ? ' on' : ''}`} onClick={() => setAutoLock(!autoLock)} />
                  <span style={{ fontSize: 11, color: 'var(--text3)' }}>Lock when budget exhausted</span>
                </div>
              </div>
              <button className="btn-p" onClick={() => showToast('Saved', 'Budget settings updated', 'success')}>Save</button>
            </div>
          </div>

          <div className={`card fu${mounted ? ' in' : ''}`} style={{ transitionDelay: '.12s' }}>
            <div className="ch"><span className="ct">Account</span></div>
            <div style={{ padding: 16 }}>
              <div className="fgroup">
                <label className="label">Display name</label>
                <input className="inp" value={displayName} onChange={e => setDisplayName(e.target.value)} />
              </div>
              <div className="fgroup">
                <label className="label">Email</label>
                <input className="inp" type="email" value={email} onChange={e => setEmail(e.target.value)} />
              </div>
              <button className="btn-p" onClick={() => showToast('Saved', 'Profile updated', 'success')}>Update profile</button>
            </div>
          </div>

          <div className={`card fu${mounted ? ' in' : ''}`} style={{ transitionDelay: '.18s' }}>
            <div className="ch"><span className="ct">Appearance</span></div>
            <div style={{ padding: '12px 16px' }}>
              <div className="tog-row">
                <div>
                  <div className="tog-title">Dark mode</div>
                  <div className="tog-sub">Toggle light / dark theme</div>
                </div>
                <div className={`tog${theme === 'dark' ? ' on' : ''}`} onClick={toggleTheme} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
